import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../../../services/util-service/utilService';
import { VariantVersionInterface } from '../../../../model/products/variant-version-interface';

import { ProductVariantInterface } from '../../../../model/products/product-variant-interface';
import { ProductInterface } from '../../../../model/products/product-interface';
import { ProductVariantVersionService } from 'src/app/services/dataServices/product-variant-version-service/product-variant-version.service';
import { CertificationVariantVersionInterface } from 'src/app/model/certifications/certification-variant-version-interface';
import { ActivatedRoute } from '@angular/router';
import { ActiveVersionPtgInterface } from '../../../../model/ptgs/ActiveVersionPtgInterface';

@Component({
    selector: 'app-version-info-box',
    templateUrl: './version-info-box.component.html',
    styleUrls: ['./version-info-box.component.css'],
    standalone: false
})
export class VersionInfoBoxComponent implements OnInit {
    @Input()
    public version:
        | VariantVersionInterface
        | CertificationVariantVersionInterface;

    @Input()
    public variant: ProductVariantInterface;

    @Input()
    public product: ProductInterface;

    @Input()
    public showExternalProductInfo: boolean;

    public previousVersionName: string;

    public activeVersionPtgs: ActiveVersionPtgInterface[] = [];
    public additionalAttributes: any[] = [];

    constructor(
        private utilService: UtilService,
        private variantVersionService: ProductVariantVersionService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe(() => {
            this.additionalAttributes = this.version.attributeValidationValues;

            const ptgAttributes: number[] = this.initializeActiveVersionPtgs();

            this.additionalAttributes = this.additionalAttributes.filter(
                (attrValValue) => {
                    return !ptgAttributes.includes(attrValValue.attribute.id);
                }
            );
            if (this.version.previousVersion != null) {
                this.previousVersionName = this.getPreviousVersionName();
            }
        });
    }

    private initializeActiveVersionPtgs(): number[] {
        this.activeVersionPtgs = [];
        const ptgAttributes: number[] = [];
        for (const ptgVersion of this.version.ptgVersions) {
            const ptg: ActiveVersionPtgInterface = {
                ptgName: ptgVersion.ptgName,
                ptgVersionNumber: ptgVersion.number,
                mandatoryFeatures: [],
                optionalFeatures: []
            };
            ptgVersion.attributeValidations.forEach((attrValidation) => {
                const attribute = attrValidation.attribute;
                ptgAttributes.push(attribute.id);
                const attributeOverview = {
                    featureName: attribute.name,
                    featureDescription: attribute.description,
                    featureValidation: this.attrValueNotNull(
                        this.getAttrValue(attribute.id)
                    )
                        ? this.checkAndTransformBoolValueFromId(attribute.id)
                        : 'Keine Angabe'
                };
                if (attrValidation.optionalValidation) {
                    ptg.optionalFeatures.push(attributeOverview);
                } else {
                    ptg.mandatoryFeatures.push(attributeOverview);
                }
            });
            ptg.mandatoryFeatures.sort((a, b) =>
                a.featureName
                    .toLowerCase()
                    .localeCompare(b.featureName.toLowerCase())
            );
            ptg.optionalFeatures.sort((a, b) =>
                a.featureName
                    .toLowerCase()
                    .localeCompare(b.featureName.toLowerCase())
            );
            this.activeVersionPtgs.push(ptg);
        }
        return ptgAttributes;
    }

    public getAttrValue(attributeId: number): string {
        const attrValue = this.version.attributeValidationValues.find(
            (attrValValue) => {
                return attrValValue.attribute.id === attributeId;
            }
        );
        if (attrValue != null) {
            return attrValue.value;
        }
    }

    public attrValueNotNull(value: string): boolean {
        return value != null;
    }

    private getPreviousVersionName(): string {
        const versionCollection = this.variantVersionService.collection;
        const previousVersion:
            | CertificationVariantVersionInterface
            | VariantVersionInterface = versionCollection.find(
            (
                version:
                    | CertificationVariantVersionInterface
                    | VariantVersionInterface
            ) => {
                return version.id === this.version.previousVersion;
            }
        );
        if (!previousVersion) {
            return null;
        }
        return previousVersion.name;
    }

    public checkAndTransformBoolValueFromId(attributeId: number): string {
        const value: string = this.utilService.transformAttributeValue(
            this.getAttrValue(attributeId)
        );
        return this.checkAndTransformBoolValue(value);
    }

    public checkAndTransformBoolValue(value: string): string {
        if (value === 'true') {
            return 'Ja';
        } else if (value === 'false') {
            return 'Nein';
        } else {
            return value;
        }
    }
}
